module.exports = __webpack_public_path__ + "img/nachos.68f2352b.svg";